import { Buyer } from "interface/buyer";
import { AxiosApi } from "./index";
import { ApiResponse } from "interface/response";
import { Vessel, VesselAuction } from "interface/vessel";

import { DropDownItem, FishingGear, CatchArea, Package, Product, Specie, Country, InternationalCountryCode, ErsMessage } from "interface/common";
import i18n from "../i18n";

let language = i18n.language;

export async function getBuyersApi({ text, id, getList = false }: { text?: string, id?: number, getList?: boolean }) {
    const apiUri = "api/common/buyers"

    try {
        const buyer = await AxiosApi.get<Buyer[]>(apiUri, {
            params: {
                id, text, getList
            }
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getBuyersFilterApi(text: string) {
    const apiUri = "api/common/buyers"

    try {
        const buyer = await AxiosApi.get<Buyer[]>(apiUri, {
            params: {
                text
            }
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getUserSettingBuyersFilterApi() {
    const apiUri = "administration/UserSettingBuyers"

    try {
        const buyer = await AxiosApi.get<Buyer[]>(apiUri, {})
                return buyer.data
    } catch (error: any) {
        throw error
    }
}


export async function getQuaySaleBuyersApi() {
    const apiUri = "api/common/quaysale-buyers"

    try {
        const buyer = await AxiosApi.get<Buyer[]>(apiUri, {
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getSpecies(text?: string, code?: number, getList: boolean = false) {
    const apiUrl = "api/common/species"

    try {
        const buyer = await AxiosApi.get<Specie[]>(apiUrl, {
            params: {
                code, text, getList, language
            }
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getFishingGearApi(text?: string, id?: number, getList: boolean = false) {
    const apiUrl = "api/common/gears"

    try {
        const buyer = await AxiosApi.get<FishingGear[]>(apiUrl, {
            params: {
                id, text, getList, language
            }
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getFDFishingGear(text?: string, code?: number, getList: boolean = false) {
    const apiUrl = "api/common/fdgears"

    try {
        const buyer = await AxiosApi.get<FishingGear[]>(apiUrl, {
            params: {
                code, text, getList
            }
        })
        return buyer.data
    } catch (error) {
        throw error
    }
}


export async function getTerminalsApi(text?: string, code?: string, getList: boolean = false) {
    const apiUri = "api/common/terminals"

    try {
        const buyer = await AxiosApi.get<DropDownItem[]>(apiUri, { params: { text, code, getList } })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getUserSettingTerminalsFilterApi() {
    const apiUri = "administration/UserSettingTerminals"

    try {
        const buyer = await AxiosApi.get<DropDownItem[]>(apiUri, {})
        return buyer.data
    } catch (error: any) {
        throw error
    }
}


export async function getQuaySalePortApi({ id, vesselId }: { id?: number, vesselId?: string }) {
    const apiUri = "api/common/quay_ports"

    try {
        const buyer = await AxiosApi.get<DropDownItem[]>(apiUri, { params: { id, vesselId } })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getConditionApi( text?: string, code?: string) {
    const apiUri = "api/common/conditions"

    try {
        const conditions = await AxiosApi.get<DropDownItem[]>(apiUri, { params: {text, code }})
        return conditions.data
    } catch (error) {
        throw error
    }
}

// export async function getAllVessel({ text, resKto, source, date, rn, id, allowCallSign = false }: { text: string, date?: Date, allowCallSign?: boolean, source?: string, resKto?: number, id?: number, rn?: string }) {
//     const apiUri = "Vessel/GetAll"

//     try {
//         const buyer = await AxiosApi.get<Vessel[]>(apiUri, {
//             params: {
//                 text, resKto, source, date, id, allowCallSign, rn
//             }
//         })
//         return buyer.data
//     } catch (error) {
//         throw error
//     }
// }

// export async function getVesselFilter(text: string) {
//     const apiUri = "Vessel/GetAll"

//     try {
//         const buyer = await AxiosApi.get<Vessel[]>(apiUri, {
//             params: {
//                 text
//             }
//         })
//         return buyer.data
//     } catch (error) {
//         throw error
//     }
// }

// export async function getUserVesselFilter(text: string) {
//     const apiUri = "Vessel/user"

//     try {
//         const buyer = await AxiosApi.get<Vessel[]>(apiUri, {
//             params: {
//                 text
//             }
//         })
//         return buyer.data
//     } catch (error) {
//         throw error
//     }
// }
// export async function getAuctionVesselNO(text: string) {
//     const apiUri = "Vessel/auctionedVessels"

//     try {
//         const buyer = await AxiosApi.get<VesselAuction[]>(apiUri, {
//             params: {
//                 text,
//                 source: "rn"

//             }
//         })
//         return buyer.data
//     } catch (error) {
//         throw error
//     }
// }



export async function getPackagesApi(text?: string) {
    const apiUri = "api/common/packages"
    try {
        const buyer = await AxiosApi.get<Package[]>(apiUri, { params: { text, language } })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getProductsApi(text: string, id?: number, preservation?: string, getList = true, noteType?: number) {
    const apiUri = "api/common/products"
    try {
        const buyer = await AxiosApi.get<Product[]>(apiUri, { params: { text, id, preservation, language, getList, noteType } })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getProductsByPreservationFilterApi(text: string, showFresh: boolean, showFrozen: boolean, showFilet: boolean) {
    const apiUri = "api/common/products-by-preservation-filter"
    try {
        const buyer = await AxiosApi.get<Product[]>(apiUri, { params: { text, showFresh, showFrozen, showFilet } })
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getMinimumProductPriceApi(id: any) {
    const apiUri = "api/common/minimum-product-price"
    try {
        const minimumPrice = await AxiosApi.get<number>(apiUri, { params: { id } })
        return minimumPrice.data
    }
    catch (error) {
        throw error
    }
}


export async function getProductsPagingApi({ take, skip, reservation, text }: { take: number, skip: number, reservation?: string, text?: string }) {
    const apiUri = "api/common/productsByPaging"
    try {
        const buyer = await AxiosApi.get<ApiResponse<Product[]>>(apiUri, { params: { take, skip, reservation, text } })
        return buyer.data
    } catch (error) {
        throw error
    }
}
export async function getProductsByUserApi() {
    const apiUri = "api/common/productsByUser"
    try {
        const buyer = await AxiosApi.get<Product[]>(apiUri)
        return buyer.data
    } catch (error) {
        throw error
    }
}

export async function getCatchAreaApi(text?: string, id?: number, getList: boolean = false) {
    const apiUrl = "api/common/catchareas"

    try {
        const catchArea = await AxiosApi.get<CatchArea[]>(apiUrl, {
            params: {
                id, text, getList
            }
        })
        return catchArea.data
    } catch (error) {
        throw error
    }
}
// export async function getCountriesApi(code?: string) {
//     const apiUrl = "api/common/countries"

//     try {
//         const catchArea = await AxiosApi.get<DropDownItem[]>(apiUrl, {
//             params: {
//                 code
//             }
//         })
//         return catchArea.data
//     } catch (error) {
//         throw error
//     }
// }

export async function getQuotaTypeApi() {
    const apiUrl = "api/common/QuotaType"

    try {
        const quotaType = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            
        })
        return quotaType.data
    } catch (error) {
        throw error
    }
}


export async function getPreservationsApi(text?: string, code?: string, getList: boolean = false) {
    const apiUrl = "api/common/preservations"

    try {
        const preservations = await AxiosApi.get<DropDownItem[]>(apiUrl, {
            params: {
                code, text, getList
            }
        });
        return preservations.data;
    } catch (error) {
        throw error
    }
}
export async function getGetInternationalCountryCodeApi() {
    const apiUrl = "api/common/internationalCountryCodes"

    try {
        const internationalCode = await AxiosApi.get<InternationalCountryCode[]>(apiUrl)
        return internationalCode.data
    } catch (error) {
        throw error
    }
} 


export async function getErsApi( data:{landingTime ?: Date,radioCallSign : string} ) {
    const apiUrl = "Ers/Get"
    try {
        const ers = await AxiosApi.get<ErsMessage[]>(apiUrl, { params: data })
        return ers.data
    } catch (error) {
        throw error
    }
}





